import { useCallback, useMemo } from 'react'

import SelectSearchable from '~/components/SelectSearchable'
import { history } from '~/helpers'
import useQueryParams from '~/hooks/useQuery'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import { CAPMPAIGNS_STATUSES as defaultOptions } from '~/modules/retailMedia/store/common/constants'

const queryKey = 'campaign_status'

type FilterCampaignStatusProps = {
  // Default is the full campaign-list catalog. The offsite advertiser
  // queue passes a shorter list so `awaiting_approval` cannot be picked
  // when the column actually displays `pending_review`.
  options?: { value: string; label: string }[]
}

const FilterCampaignStatus: React.FC<FilterCampaignStatusProps> = ({
  options: optionsProp
}) => {
  const { t } = useAPPTranslation()
  const statusOptions = optionsProp ?? defaultOptions

  /**
   * <Handle change>
   */
  const queryParams = useQueryParams()
  const selectedValue = queryParams.get(queryKey) as PublisherTagId

  const selectedTag = useMemo(
    () => statusOptions.find(({ value }) => value === selectedValue) || null,
    [selectedValue, statusOptions]
  )

  const handleChange = useCallback(
    (option: Option) => {
      const value = option?.value

      if (!value) queryParams.delete(queryKey)

      if (value) queryParams.set(queryKey, value)

      queryParams.set('page', '1')

      history.replace({ search: queryParams.toString() })
    },
    [queryParams]
  )

  return (
    <SelectSearchable
      key={selectedTag?.value}
      name="campaign-status-select"
      placeholder={t('rm:filterByCampaignStatus')}
      options={statusOptions}
      onChange={handleChange}
      isClearable
      defaultValue={selectedTag}
      isSearchable
      noOptionsMessage={() => t('c:messages.noResultsFound')}
      size="small"
    />
  )
}

export default FilterCampaignStatus
